export const formatAlertDateTime = (timestamp: number) =>
  new Date(timestamp).toLocaleString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  })

export const formatAlertPrice = (value?: number) => {
  if (value === undefined || value === null || Number.isNaN(value)) return '—'
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 5,
  }).format(value)
}

export const formatAlertProfit = (value: number) => `$${value.toFixed(2)}`

export const formatLotSize = (value: number) =>
  Number(value).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 8 })
